export const ShipmentMode = {
  AERO: 'AERO',
  GENERIC: 'GENERIC',
  // medical accounts
  DTP: 'DTP',
  BOT: 'BOT',
  CGT: 'CGT',
  CTS: 'CTS',
  DTL: 'DTL',
  DFP: 'DFP',
  // other modes are not supported
  UNKNOWN: 'UNKNOWN',
};
